import { fetchData } from '@/utils/fetch'

export const retrieveProductList = (data, options) => {
  return fetchData('/appb/b2b/product/searchKeyWordV2?itemNumber=50', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}

export const retrieveImageSearchList = (data, options) => {
  return fetchData('/appb/b2b/product/searchImage', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}
